export default __webpack_public_path__ + "static/media/tree-warning.e88563dc.svg";